"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mdContainerMessage = exports.mdContainerDetails = void 0;
var md_utils_1 = require("./md-utils");
// containers
// ref: https://github.com/markdown-it/markdown-it-container
// ::: details Detail
//   summary comes here
// :::
exports.mdContainerDetails = {
    validate: function (params) {
        return params.trim().match(/^details\s+(.*)$/);
    },
    render: function (tokens, idx) {
        var m = tokens[idx].info.trim().match(/^details\s+(.*)$/);
        if (tokens[idx].nesting === 1) {
            // opening tag
            return ("<details><summary>" +
                md_utils_1.escapeHtml(m[1]) +
                '</summary><div class="details-content">');
        }
        else {
            // closing tag
            return "</div></details>\n";
        }
    },
};
// ::: message alert
//   text
// :::
var msgClassRegex = /^message\s*([0-9a-z -_]{0,15})$/;
exports.mdContainerMessage = {
    validate: function (params) {
        return params.trim().match(msgClassRegex);
    },
    render: function (tokens, idx) {
        var m = tokens[idx].info.trim().match(msgClassRegex);
        if (tokens[idx].nesting === 1) {
            // opening tag
            return '<div class="msg ' + md_utils_1.escapeHtml(m[1]) + '">';
        }
        else {
            // closing tag
            return "</div>\n";
        }
    },
};
